import styled, {keyframes} from 'styled-components'

const rotate = keyframes`
    100% { transform: rotate(360deg); }
`

export const StyledSpinner = styled.svg<{size?: number; fill?: string; $trackColor?: string}>`
    display: block;
    width: ${({size}) => size || 20}px;
    height: ${({size}) => size || 20}px;
    animation: ${rotate} 0.8s linear infinite;

    circle {
        strokewidth: 2;
    }

    .track {
        stroke: ${({$trackColor}) => $trackColor || 'rgba(0, 0, 0, 0.1)'};
    }

    .progress {
        stroke: ${({fill}) => fill || 'currentColor'};
        strokelinecap: round;
    }
`
